import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
    login: {
        'loginTitle': 'Welcome',
        'loginForget': 'Forget',
        'username': 'Your username',
        'password': 'Your password',
        'email': 'Your Email',
        'CAPTCHA': 'CAPTCHA for Email',
        'change': 'Change',
        'remember': 'Remember me',
        'forget': 'Forget password',
        'loginOn': 'Log on',
        'login': 'Login',
        'loginIn': 'Login...',
        'retrieve': 'Retrieve',
        'retrieving': 'Retrieving...',
        'simulation': 'Virtual simulation laboratory',
        'dimension': '/Let education have one more dimension',
        'formusername': 'User name cannot be empty',
        'formpassword': 'Password cannot be less than 5 digits and cannot be empty',
        'formemail': 'Mailbox cannot be empty',
        'formCAPTCHA': 'The verification code can not be empty'
    },
    ...enLocale
}
export default en;


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js